import { SearchProps } from '~components/form-fields/search';

import { selectCaseManagerUsers } from '~care-workers/selectors/users';
import { selectLookupClients } from '~main/selectors/clients/clients';

export const searchFields: SearchProps = {
  // Always applied: the API needs a range, and statements overlapping it are shown
  statement_date: {
    defaultShow: true,
    persist: true,
    type: 'date-range',
    field: 'statement_date',
    caption: 'Statement Date',
  },
  case_manager: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'case_manager',
    caption: 'Care Manager',
    placeholder: 'Select...',
    selectorOptions: selectCaseManagerUsers,
  },
  client_id: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'client_id',
    caption: 'Client',
    placeholder: 'Select...',
    selectorOptions: selectLookupClients,
  },
};
